"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.passengersToTripSteps = exports.passengersToTripStepsSelect = void 0;
var lodash_1 = require("lodash");
var moment_1 = __importDefault(require("@ambler/moment"));
var utils_1 = require("../utils");
var core_1 = require("../core");
var formatter_1 = require("../formatter");
var lodash_2 = require("lodash");
exports.passengersToTripStepsSelect = {
    id: true,
    status: true,
    direction: true,
    timeReference: true,
    departureTime: true,
    arrivalTime: true,
    timezone: true,
    originServiceRaw: true,
    destinationServiceRaw: true,
    preferredMt: {
        select: {
            id: true,
        },
    },
    origin: {
        select: {
            id: true,
            mainText: true,
            secondaryText: true,
            address: {
                select: {
                    id: true,
                    geopoint: true,
                    city: true,
                },
            },
        },
    },
    destination: {
        select: {
            id: true,
            mainText: true,
            secondaryText: true,
            address: {
                select: {
                    id: true,
                    geopoint: true,
                    city: true,
                },
            },
        },
    },
    patient: {
        select: {
            id: true,
            firstname: true,
            lastname: true,
            gender: true,
            birthdate: true,
        },
    },
    optimizationRequestRows: {
        select: {
            id: true,
            detour: true,
            departureTime: true,
            arrivalTime: true,
            request: {
                select: {
                    isMain: true,
                    status: true,
                },
            },
        },
    },
    trip: {
        select: {
            id: true,
            assignedMt: {
                select: {
                    id: true,
                },
            },
        },
    },
    driverEvents: {
        select: {
            id: true,
            type: true,
            firedAt: true,
            mt: {
                select: {
                    id: true,
                },
            },
        },
    },
};
var passengersToTripSteps = function (passengers_, _a) {
    var _b, _c;
    var _d = _a === void 0 ? {} : _a, _e = _d.optimizedPassengers, optimizedPassengers = _e === void 0 ? [] : _e, _f = _d.showTime, showTime = _f === void 0 ? true : _f, bookingRequest = _d.bookingRequest;
    var optimizedBrPassengerIds = optimizedPassengers.map(function (_a) {
        var id = _a.id;
        return id;
    });
    var getOptimRow = function (rows) {
        return (0, lodash_2.findLast)(rows, function (row) { return row.request.isMain && row.request.status === 'SUCCESS'; });
    };
    var wasPassengerBooked = function (passenger) {
        return !(0, utils_1.isIn)([
            // Confirmable phase
            'CREATED',
            'DELAYED',
            'ABORTED',
            'ABORTED_MERGED',
            'REQUESTED',
            // Dispatching phase
            'DISPATCHING',
            'HPTL_EDIT_DROP',
            'PTNT_DROP',
            'HPTL_DROP',
            'TC_PTNT_DROP',
            'TC_HPTL_DROP',
            'TC_TPTR_NOT_FOUND',
            'HPTL_TPTR_NOT_FOUND',
            'TC_HPTL_TPTR_NOT_FOUND',
            'TC_DISPATCH_TIMEOUT',
            'HPTL_DISPATCH_TIMEOUT',
        ], passenger.status);
    };
    function isPatientIdentityVisible(passenger) {
        var _a, _b;
        if (bookingRequest) {
            if ((_a = bookingRequest.bookedPassengers) === null || _a === void 0 ? void 0 : _a.some(function (p) { return p.id === passenger.id; })) {
                return true;
            }
            var numberOfRecentPassengers = bookingRequest.numberOfRecentPassengers;
            var wasBooked = wasPassengerBooked(passenger);
            var isPreferredMt = ((_b = passenger.preferredMt) === null || _b === void 0 ? void 0 : _b.id) === bookingRequest.mt.id;
            var isDefaultMt = bookingRequest.mt.patientConfigs.some(function (config) { return config.patient.id === passenger.patient.id; });
            return wasBooked || isDefaultMt || isPreferredMt || Boolean(numberOfRecentPassengers);
        }
        return true;
    }
    var passengers = (0, lodash_1.sortBy)((0, lodash_1.uniqBy)(__spreadArray(__spreadArray([], passengers_, true), optimizedPassengers, true), 'id'), function (p) {
        var _a, _b;
        if (optimizedPassengers.length) {
            var optimizationRequestRow = getOptimRow(p.optimizationRequestRows);
            return [
                (_a = optimizationRequestRow === null || optimizationRequestRow === void 0 ? void 0 : optimizationRequestRow.departureTime) !== null && _a !== void 0 ? _a : p.departureTime,
                (_b = optimizationRequestRow === null || optimizationRequestRow === void 0 ? void 0 : optimizationRequestRow.arrivalTime) !== null && _b !== void 0 ? _b : p.arrivalTime,
            ];
        }
        return [p.departureTime, p.arrivalTime];
    });
    var stepsByKey = {};
    var _loop_1 = function (passenger) {
        var _loop_2 = function (type) {
            var passengerTime = (function () {
                var optimizationRequestRow = getOptimRow(passenger.optimizationRequestRows);
                if (optimizedPassengers.length && optimizationRequestRow) {
                    return type === 'PEC' ? optimizationRequestRow.departureTime : optimizationRequestRow.arrivalTime;
                }
                return type === 'PEC' ? passenger.departureTime : passenger.arrivalTime;
            })();
            var realPassengerTime = (function () {
                var _a, _b, _c, _d;
                if (type === 'PEC') {
                    return ((_b = (_a = passenger.driverEvents.find(function (d) { var _a; return d.mt.id === ((_a = passenger.trip.assignedMt) === null || _a === void 0 ? void 0 : _a.id) && d.type === 'PICK_UP'; })) === null || _a === void 0 ? void 0 : _a.firedAt) !== null && _b !== void 0 ? _b : null);
                }
                return ((_d = (_c = passenger.driverEvents.find(function (d) { var _a; return d.mt.id === ((_a = passenger.trip.assignedMt) === null || _a === void 0 ? void 0 : _a.id) && d.type === 'DROP_OFF'; })) === null || _c === void 0 ? void 0 : _c.firedAt) !== null && _d !== void 0 ? _d : null);
            })();
            var place = type === 'PEC' ? passenger.origin : passenger.destination;
            var dateTime = (0, moment_1.default)(passengerTime).toISOString();
            var realDateTime = realPassengerTime ? (0, moment_1.default)(realPassengerTime).toISOString() : null;
            var serviceRaw = type === 'PEC' ? passenger.originServiceRaw : passenger.destinationServiceRaw;
            var isMainTime = (type === 'PEC' && passenger.timeReference === 'DEPARTURE') ||
                (type === 'DÉPOSE' && passenger.timeReference === 'ARRIVAL');
            var timeLabelType = (function () {
                if (!showTime) {
                    return 'HIDE';
                }
                if (!core_1.beforeBookedStatuses.includes(passenger.status) && passenger.direction === 'OUTBOUND') {
                    return 'SHOW';
                }
                if (passenger.timeReference === 'UNKNOWN') {
                    return 'HIDE';
                }
                if ((0, utils_1.isIn)(['DISPATCHING', 'PREBOOKED'], passenger.status) && optimizedPassengers.length === 0 && !isMainTime) {
                    return 'SHOW_ESTIMATED_TIME_INPUT';
                }
                return 'SHOW';
            })();
            var key = "".concat(place.id, "_").concat(dateTime);
            if (!stepsByKey[key]) {
                if (place.mainText == null || place.secondaryText == null || place.address == null) {
                    throw Error('Missing elements to compute trip steps');
                }
                stepsByKey[key] = {
                    key: key,
                    mainText: place.mainText,
                    secondaryText: place.secondaryText,
                    singleLineText: [place === null || place === void 0 ? void 0 : place.mainText, serviceRaw, (_b = place === null || place === void 0 ? void 0 : place.address) === null || _b === void 0 ? void 0 : _b.city].filter(Boolean).join(', '),
                    geopoint: place.address.geopoint,
                    serviceRaw: serviceRaw,
                    type: type,
                    dateTime: dateTime,
                    isEstimated: !isMainTime,
                    isTimeUnknown: passenger.timeReference === 'UNKNOWN',
                    timezone: passenger.timezone,
                    timeInLocalTimezone: (0, formatter_1.formatTime)(dateTime, isMainTime, passenger.timezone),
                    isFinalStep: false,
                    isNew: false,
                    isBeforeNewStep: false,
                    isCanceled: false,
                    showCanceledBar: false,
                    timeLabelType: timeLabelType,
                    direction: passenger.direction,
                    patients: [],
                    realDateTime: realDateTime,
                    realTimeInLocalTimezone: realDateTime ? (0, formatter_1.formatTime)(realDateTime, true, passenger.timezone) : null,
                    scheduledTime: dateTime,
                    scheduledTimeInLocalTimezone: (0, formatter_1.formatTime)(dateTime, isMainTime, passenger.timezone),
                };
            }
            var isNew = optimizedBrPassengerIds.length ? !(optimizedBrPassengerIds === null || optimizedBrPassengerIds === void 0 ? void 0 : optimizedBrPassengerIds.includes(passenger.id)) : false;
            stepsByKey[key].patients.push(__assign(__assign({}, passenger.patient), { isNew: isNew, isCanceled: core_1.canceledAbortedPassengerStatuses.includes(passenger.status) ||
                    core_1.noridePassengerStatuses.includes(passenger.status) ||
                    passenger.status == 'UNBOOKED', passengerId: passenger.id, formattedPatientName: (0, formatter_1.formatPatientName)(passenger.patient, !isPatientIdentityVisible(passenger)) }));
        };
        for (var _h = 0, _j = ['PEC', 'DÉPOSE']; _h < _j.length; _h++) {
            var type = _j[_h];
            _loop_2(type);
        }
    };
    for (var _i = 0, passengers_1 = passengers; _i < passengers_1.length; _i++) {
        var passenger = passengers_1[_i];
        _loop_1(passenger);
    }
    var steps = (0, lodash_1.sortBy)(Object.values(stepsByKey), 'dateTime');
    steps[steps.length - 1].isFinalStep = true;
    // * Compute estimated real date time when possible (once the first one is known)
    for (var i = 0; i < steps.length; i++) {
        var step = steps[i];
        if (step.realDateTime) {
            step.scheduledTimeInLocalTimezone = (0, formatter_1.formatTime)(step.dateTime, true, step.timezone);
            continue;
        }
        var prevStep = steps[i - 1];
        if (!prevStep) {
            continue;
        }
        if (!prevStep.realDateTime) {
            continue;
        }
        var diff = (0, moment_1.default)(step.dateTime).diff((0, moment_1.default)(prevStep.dateTime), 'seconds');
        step.scheduledTimeInLocalTimezone = (0, formatter_1.formatTime)(step.dateTime, true, step.timezone);
        step.realDateTime = (0, moment_1.default)(prevStep.realDateTime).add(diff, 'seconds').toISOString();
        step.realTimeInLocalTimezone = (0, formatter_1.formatTime)(step.realDateTime, false, step.timezone);
    }
    // * Adjust real date time if it's the same as scheduled
    for (var i = 0; i < steps.length; i++) {
        var step = steps[i];
        if (step.realDateTime) {
            if ((0, moment_1.default)(step.realDateTime).isSame((0, moment_1.default)(step.dateTime), 'minute')) {
                step.scheduledTimeInLocalTimezone = step.realTimeInLocalTimezone;
                step.realDateTime = null;
                step.realTimeInLocalTimezone = null;
            }
        }
    }
    for (var _g = 0, steps_1 = steps; _g < steps_1.length; _g++) {
        var step = steps_1[_g];
        if (step.patients.every(function (p) { return p.isNew; })) {
            step.isNew = true;
        }
        if (step.patients.every(function (p) { return p.isCanceled; })) {
            step.isCanceled = true;
        }
    }
    for (var i = 0; i < steps.length - 1; i++) {
        if (steps[i + 1].isNew) {
            steps[i].isBeforeNewStep = true;
        }
    }
    if (steps.length > 2) {
        if (steps[0].isCanceled) {
            steps[0].showCanceledBar = true;
        }
        if ((_c = steps.at(-1)) === null || _c === void 0 ? void 0 : _c.isCanceled) {
            steps[steps.length - 1].showCanceledBar = true;
            steps[steps.length - 2].showCanceledBar = true;
        }
    }
    return steps;
};
exports.passengersToTripSteps = passengersToTripSteps;
//# sourceMappingURL=trip-step.js.map